export default __webpack_public_path__ + "static/media/fundo.dadd19d8.mp4";